import { useEffect } from "react";
import { type AcquiredPropertySearch } from "../types";
import { useAcquiredRequests } from "../hooks/useAcquiredRequests";
import { RequestTable, type RequestFeedGridProps } from "./RequestFeedGrid";

interface Props extends RequestFeedGridProps {
  search: AcquiredPropertySearch;
  userId: string;
  isSharable: boolean;
  revalidateIfStale?: boolean;
  onSearchChange: (next: AcquiredPropertySearch, replace?: boolean) => void;
}

export const AcquiredRequestFeedGrid: React.FC<Props> = ({
  search,
  userId,
  isSharable,
  revalidateIfStale,
  onSearchChange,
  ...actions
}) => {
  const { data, error, isLoading, isValidating } = useAcquiredRequests(
    search,
    userId,
    isSharable,
    revalidateIfStale
  );
  useEffect(() => {
    if (
      data &&
      search.page > 0 &&
      search.page * search.pageSize >= data.count
    ) {
      onSearchChange(
        {
          ...search,
          page: Math.max(0, Math.ceil(data.count / search.pageSize) - 1),
        },
        true
      );
    }
  }, [data, search]);

  return (
    <>
      <RequestTable
        {...actions}
        rows={data?.list ?? []}
        pagination={{
          search,
          count: data?.count ?? 0,
          loading: isLoading || isValidating,
          hasError: Boolean(error),
          onChange: onSearchChange,
        }}
      />
    </>
  );
};
